// Navigation header component with responsive menu
import React, { useState } from "react";
import styled from "styled-components";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Icons } from "@/assets/icons";
import Resume from "../RenatoDelboni0826.pdf";
import { useLanguage } from "../contexts/LanguageContext";
import { getTranslation } from "../translations/translations";
import LanguageSelector from "./LanguageSelector";

function Header() {
  const [burgerStatus, setBurgerStatus] = useState(false);
  const { language } = useLanguage();

  return (
    <Container>
      <LeftIcons>
        <a href="/">
          <img src={Icons.home} alt="" />
        </a>
        <a href={Resume} download>
          <img src={Icons.resume} alt="" />
        </a>
      </LeftIcons>
      <Menu>
        <a href="/aboutme">
          <span>{getTranslation(language, "nav.aboutMe")}</span>
        </a>
        <a href="/projects">
          <span>{getTranslation(language, "nav.projects")}</span>
        </a>
        <a href="/mini-projects">
          <span id="mp">{getTranslation(language, "nav.miniProjects")}</span>
        </a>
        <a href="/tests">
          <span>{getTranslation(language, "nav.tests")}</span>
        </a>
        <a href="/javascript30">
          <span>{getTranslation(language, "nav.javascript30")}</span>
        </a>
      </Menu>
      <RightMenu>
        <LanguageSelectorWrapper>
          <LanguageSelector />
        </LanguageSelectorWrapper>
        <CustomMenu onClick={() => setBurgerStatus(true)} />
      </RightMenu>
      <BurgerNav show={burgerStatus}>
        <CloseWrapper>
          <CustomClose onClick={() => setBurgerStatus(false)} />
        </CloseWrapper>
        <a href="/">
          <li>{getTranslation(language, "nav.home")}</li>
        </a>
        <a href="/aboutme">
          <li>{getTranslation(language, "nav.aboutMe")}</li>
        </a>
        <a href="/projects">
          <li>{getTranslation(language, "nav.projects")}</li>
        </a>
        <a href="/mini-projects">
          <li>{getTranslation(language, "nav.miniProjects")}</li>
        </a>
        <a href="/tests">
          <li>{getTranslation(language, "nav.tests")}</li>
        </a>
        <a href="/javascript30">
          <li>{getTranslation(language, "nav.javascript30")}</li>
        </a>
        <RightIcons>
          <a href="https://github.com/netsujr" target="_blank" rel="noreferrer">
            <img src={Icons.github} alt="Github" />
          </a>
          <a
            href="https://www.linkedin.com/in/delbonirenato/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Icons.linkedin} alt="Linkedin" />
          </a>
        </RightIcons>
      </BurgerNav>
    </Container>
  );
}

export default Header;

const Container = styled.div`
  background: rgba(169, 225, 255, 1);
  min-height: 60px;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  margin-bottom: 10px;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;

  @media (max-width: 768px) {
    padding: 0px 15px;
    min-height: 55px;
  }

  @media (max-width: 480px) {
    padding: 0px 10px;
    min-height: 50px;
  }

  img {
    height: 60px;
    @media (max-width: 768px) {
      height: 50px;
    }
    @media (max-width: 480px) {
      height: 45px;
    }
  }

  a {
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 10px;
    flex-wrap: nowrap;
    cursor: pointer;
    color: black;

    @media (max-width: 768px) {
      padding: 0 8px;
    }

    span {
      font-size: 13px;
      letter-spacing: 0.4px;
      position: relative;

      @media (max-width: 768px) {
        font-size: 12px;
      }

      &:after {
        content: "";
        height: 1px;
        background: black;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -6px;
        opacity: 0;
        transform-origin: left center;
        transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
        transform: scaleX(0);
      }
    }

    &:hover {
      span:after {
        transform: scaleX(1);
        opacity: 1;
      }
    }
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 1;

  @media (max-width: 768px) {
    display: none;
  }

  a {
    img {
      position: absolute;
      height: 30px;
      left: -15px;
      top: -15px;
      transform: rotate(-90deg);
      object-fit: contain;
    }
  }
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 20px;

  @media (max-width: 768px) {
    gap: 8px;
    margin-left: 10px;
  }
`;

const LanguageSelectorWrapper = styled.div`
  @media (max-width: 768px) {
    display: flex;
  }
`;

const CustomMenu = styled(MenuIcon)`
  color: black;
`;

const BurgerNav = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 300px;
  max-width: 85vw;
  background-color: white;
  z-index: 3;
  list-style: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
  transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};
  transition: transform 250ms ease-in-out;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 480px) {
    width: 100vw;
    max-width: 100vw;
    padding: 15px;
  }

  li {
    padding: 15px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    color: black;
    font-weight: 200;

    @media (max-width: 480px) {
      padding: 12px 0;
      font-size: 14px;
    }

    &:hover {
      font-weight: 500;
      letter-spacing: 1px;
    }

    a {
      font-weight: 600;
    }
  }
`;

const CustomClose = styled(CloseIcon)`
  color: black;
  cursor: pointer;
`;

const CloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const RightIcons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  img {
    height: 40px;
    padding: 2px;

    &:hover {
      height: 42px;
    }
  }
`;

const LeftIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 480px) {
    gap: 8px;
  }

  img {
    height: 33px;
    @media (max-width: 768px) {
      height: 28px;
    }
    @media (max-width: 480px) {
      height: 25px;
    }
  }
`;
